import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import Typewriter from 'typewriter-effect';
import styles from './AIThinkingComponent.module.css';

/**
 * AIThinkingComponent - Recreated based on the video reference.
 * 
 * @param {Object} props
 * @param {string} props.thinking_title - The main status title (from WebSocket JSON)
 * @param {string} props.thinking_desc - The initial thought block text (from WebSocket JSON)
 * @param {Array<{title: string, description: string}>} [props.results] - Generated answers
 * @param {boolean} [props.isThinking=false] - Whether the status is currently shining
 * @param {string} [props.thoughtDuration] - Duration text (e.g. "Thought for 4s")
 * @param {Function} [props.onAnswerNow] - Callback for the "Answer now" bypass
 */
const AIThinkingComponent = ({
    thinking_title,
    thinking_desc,
    results = [],
    isThinking = false,
    thoughtDuration,
    onAnswerNow
}) => {
    const [isExpanded, setIsExpanded] = useState(true);

    // Auto-collapse when results start appearing (optional UX refinement)
    useEffect(() => {
        if (results.length > 0 && isExpanded) {
            // Keep expanded initially, let user collapse manually if desired
        }
    }, [results]);

    return (
        <div className={styles.container}>
            {/* Thinking / Status Block */}
            <div className={styles.thinkingBlock}>
                <div className={styles.statusHeader}>
                    <div
                        className={styles.statusTitleWrapper}
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        <span className={`${styles.statusText} ${isThinking ? styles.statusShine : ''}`}>
                            {thoughtDuration && !isThinking ? thoughtDuration : thinking_title}
                        </span>
                        <ChevronRight className={`${styles.chevron} ${isExpanded ? styles.expanded : ''}`} />
                    </div>

                    {isThinking && onAnswerNow && (
                        <span className={styles.answerNowLink} onClick={onAnswerNow}>
                            Answer now
                        </span>
                    )}
                </div>

                {/* Thought Process Content (Types out characters once) */}
                {/* Thought Process Content (Types out characters once) */}
                {isExpanded && thinking_desc && (
                    <div className={styles.thoughtProcess}>
                        <Typewriter
                            key={thinking_desc}
                            onInit={(typewriter) => {
                                typewriter
                                    .typeString(thinking_desc)
                                    .start();
                            }}
                            options={{
                                delay: 20,
                                cursor: '', // No cursor for thought process
                                autoStart: true,
                                loop: false,
                            }}
                        />
                    </div>
                )}
            </div>

            {/* Results / Answer Area */}
            {results.length > 0 && (
                <div className={styles.resultsArea}>
                    {results.map((result, index) => (
                        <div key={`res-${index}`} className={styles.resultItem}>
                            <h4 className={styles.resultTitle}>
                                <Typewriter
                                    onInit={(typewriter) => {
                                        typewriter.typeString(result.title).start();
                                    }}
                                    options={{ delay: 15, cursor: '', autoStart: true }}
                                />
                            </h4>
                            {result.description && (
                                <div className={styles.resultDescription}>
                                    <Typewriter
                                        onInit={(typewriter) => {
                                            typewriter.typeString(result.description).start();
                                        }}
                                        options={{
                                            delay: 10,
                                            cursor: '▊',
                                            autoStart: true
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AIThinkingComponent;
